
import Vue from 'vue'
import 'vue-slider-component/theme/default.css'
import { colorTemperatureGradient } from '@/utils/colorTemperature'
import { formatTechnicalValue } from '@/utils/technicalFilters'

if (process.client) {
  Vue.component('VueSlider', require('vue-slider-component'))
}

const BOUND_KEYS = ['minimum', 'maximum']

export default {
  name: 'ProductTechnicalFilterSlider',
  props: {
    filter: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sliderKey() {
      const { bounds, step } = this.filter
      return `${bounds.min}:${bounds.max}:${step}`
    },
    dotSize() {
      return this.large ? 32 : 24
    },
    isColorTemperature() {
      return this.filter.key === 'color_temperature'
    },
    minOnTop() {
      const [low, high] = this.value
      return low === high && high >= this.filter.bounds.max
    },
    railStyle() {
      return this.isColorTemperature
        ? {
            background: colorTemperatureGradient(this.filter.bounds),
            boxShadow: 'inset 0 0 0 1px rgba(15, 23, 42, 0.12)',
          }
        : { backgroundColor: '#e5e7eb' }
    },
    processStyle() {
      return this.isColorTemperature
        ? { boxShadow: '0 0 0 2px #152131' }
        : { backgroundColor: '#152131' }
    },
  },
  mounted() {
    this.$nextTick(this.describeDots)
  },
  updated() {
    this.describeDots()
  },
  methods: {
    describeDots() {
      const dots = this.$el.querySelectorAll('.vue-slider-dot')
      if (dots.length !== BOUND_KEYS.length) return

      BOUND_KEYS.forEach((key, index) => {
        dots[index].setAttribute(
          'aria-label',
          this.$t(`components.productTechnicalFilters.${key}`, {
            name: this.label,
          })
        )
        dots[index].setAttribute(
          'aria-valuetext',
          formatTechnicalValue(
            this.value[index],
            this.filter,
            this.$i18n.locale
          )
        )
      })
    },
  },
}
